import React, { FC } from 'react';
import { StringField } from '../../../../String';
import { ValidationErrors } from '../../../../../common';
import { IUserProfileEditFrontend } from 'src/modules/users/widgets';

interface IManualFieldProps {
  name: string;
  handleManualUpdate: (fio: IUserProfileEditFrontend.IFioObject) => void;
}

const validate = (value: string): string | undefined => {
  if (value?.trim()) return;

  return ValidationErrors.required();
};

export const ManualField: FC<IManualFieldProps> = ({ name, handleManualUpdate }) => (
  <>
    <StringField
      name={`${name}.lastName`}
      label="Фамилия"
      placeholder="Введите фамилию"
      onChange={(e) => handleManualUpdate({ lastName: e.target.value })}
      // validate={validate}
    />
    <StringField
      name={`${name}.firstName`}
      label="Имя"
      placeholder="Введите имя"
      onChange={(e) => handleManualUpdate({ firstName: e.target.value })}
      // validate={validate}
    />
    <StringField
      name={`${name}.middleName`}
      label="Отчество"
      placeholder="Введите отчество"
      onChange={(e) => handleManualUpdate({ middleName: e.target.value })}
    />
  </>
);
